export default {
    en: {
        accounts: 'Account',
        sum_type: 'Sum type',
        sales_invoice:'Sales Invoice ID',
        purchase_invoice: 'Purchase Invoice ID',
        invoice_number: 'Invoice Number',
        total_sum: 'Total Sum',
        vat_sum: 'VAT',
        sum: 'Sum'
    },
    et: {
        accounts: 'Konto',
        sum_type: 'Summa tüüp',
        sales_invoice:'Müügiarve ID',
        purchase_invoice: 'Ostuarve ID',
        invoice_number: 'Arve number',
        total_sum: 'Kogusumma',
        vat_sum: 'VAT',
        sum: 'Summa'
    }

}